// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { editCareer, getCareerById } from "../../../features/career";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const EditCareer = () => {
  const { id } = useParams<{ id: string }>();
  const { career, status } = useSelector((state: any) => state.career);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    id: id,
    role_title: "",
    role: "",
    location: "",
    employment_type: "Full Time", // Default employment type
  });

  useEffect(() => {
    // Fetch the career data by ID
    dispatch(getCareerById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && career?.data) {
      const data = career.data;
      setFormData({
        id: data._id,
        role_title: data.role_title,
        role: data.role,
        location: data.location,
        employment_type: data.employment_type || "Full Time",
      });
    }
  }, [status, career]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    dispatch(editCareer({ id, updatedCareer: formData }))
      .then((res: any) => {
        toast.success(res.payload.message || "Career updated successfully.");
        navigate("/career");
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("Failed to update career.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit Career
          </SoftTypography>
        </SoftBox>
        <SoftBox component="form" role="form">
          {/* Role Title Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Role Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="role_title"
              placeholder="Enter the role title"
              value={formData.role_title}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Role Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Role
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="role"
              placeholder="Enter the role"
              value={formData.role}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Location Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Location
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="location"
              placeholder="Enter the location"
              value={formData.location}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Employment Type Dropdown */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Employment Type
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="employment_type"
              placeholder="Enter the employment type"
              value={formData.employment_type}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditCareer;
